export const CustomCard = {
	iconColor: 'var(--epods--card-header-icon-color)',
	iconSize: 'var(--epods--card-header-icon-size)',
	iconMargin: 'var(--epods--card-header-icon-margin)',

	//footerMargin: 'var(--epods--card-footer-margin)',

	headerFontSize: 'var(--epods--card-header-font-size)',
	headerFontHeight: 'var(--epods--card-header-font-height)',
	headerFontFont: 'var(--epods--card-header-font-font)',
};
